<div class="lug-dropdown" [style.top]="topDistance" [ngClass]="{ show: isOpen }">
  <ng-content></ng-content>
</div>
